import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { privateAxios } from "../axiosInstances";
import { exhibitorInspectorKeys } from "../query-keys";
import { UpdateExhibitorInspectorForm } from "../schemas";

const updateExhibitorInspector = async ({
  id,
  data,
}: {
  id: string;
  data: UpdateExhibitorInspectorForm;
}) => {
  try {
    const { data: response } = await privateAxios.patch(
      `/exhibitor-inspector/${id}`,
      data
    );
    return response;
  } catch (error) {
    if (isAxiosError(error))
      error.message = error.response?.data.message ?? error.message;
    throw error;
  }
};

export const useUpdateExhibitorInspectorMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateExhibitorInspector,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: exhibitorInspectorKeys.all,
      });
    },
  });
};
